module.exports = __webpack_public_path__ + "img/logo@2x.af64084c.png";